'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n'], ['\n  position: relative;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _DialogConstants = require('./DialogConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Div = _styledComponents2.default.div.withConfig({
  displayName: 'UIDialog__Div'
})(_templateObject);

var UIDialog = function (_React$Component) {
  _inherits(UIDialog, _React$Component);

  function UIDialog() {
    _classCallCheck(this, UIDialog);

    return _possibleConstructorReturn(this, (UIDialog.__proto__ || Object.getPrototypeOf(UIDialog)).apply(this, arguments));
  }

  _createClass(UIDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          centered = _props.centered,
          children = _props.children,
          className = _props.className,
          _dialogWidth = _props._dialogWidth,
          style = _props.style,
          use = _props.use,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['centered', 'children', 'className', '_dialogWidth', 'style', 'use', 'size']);

      return _react2.default.createElement(
        Div,
        _extends({}, rest, {
          className: (0, _reactUtils.classNames)('private-modal', _DialogConstants.USE_CLASSES[use], _DialogConstants.SIZE_CLASSES[size], 'uiDialog-root', className, { 'private-modal--centered': centered }),
          style: _extends({ width: _dialogWidth }, style)
        }),
        children
      );
    }
  }]);

  return UIDialog;
}(_react2.default.Component);

UIDialog.propTypes = {
  centered: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  _dialogWidth: _react.PropTypes.number,
  role: _react.PropTypes.string,
  size: _react.PropTypes.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
  style: _react.PropTypes.object,
  use: _react.PropTypes.oneOf(Object.keys(_DialogConstants.USE_CLASSES))
};

UIDialog.defaultProps = {
  centered: false,
  use: 'default',
  size: 'medium'
};

UIDialog.Selector = Div;

exports.default = UIDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dialog/UIDialog.js
// module id = 328
// module chunks = 0